import { render, staticRenderFns } from "./AppScoresNCAAF.vue?vue&type=template&id=307d3a78&"
import script from "./AppScoresNCAAF.vue?vue&type=script&lang=js&"
export * from "./AppScoresNCAAF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports